import {
	DirectionalLight,
	Group,
	Object3D,
	Object3DEventMap,
	PerspectiveCamera,
	Vector3,
	WebGLRenderer,
} from 'three';

import { ThreeDEnv } from './types';
import { isWebkit } from '@shared/lib/feature-detects';

// ---

const IS_WEBKIT = isWebkit();

const DEVICE_PIXEL_RATIO_LIMIT = 4;
const DEVICE_PIXEL_RATIO_WITH_BUFFER = window.devicePixelRatio + 2;
const DEFAULT_PIXEL_RATIO =
	DEVICE_PIXEL_RATIO_WITH_BUFFER > DEVICE_PIXEL_RATIO_LIMIT
		? DEVICE_PIXEL_RATIO_LIMIT
		: DEVICE_PIXEL_RATIO_WITH_BUFFER;

console.log(
	`Device pixel ratio: ${window.devicePixelRatio}, using ${DEFAULT_PIXEL_RATIO}`
);

export class Timer3dEnv implements ThreeDEnv {
	public renderer: WebGLRenderer;
	public scene: Group<Object3DEventMap>;
	public camera: PerspectiveCamera;
	public light: DirectionalLight;

	public entireTimer: Object3D;
	private topHemisphere: Object3D;

	constructor(scene: Group<Object3DEventMap>, canvas: HTMLCanvasElement) {
		this.light = this.createLight();
		this.camera = this.createCamera();
		this.renderer = this.createRenderer(canvas);
		this.scene = scene;

		scene.add(this.light);
		scene.add(this.light.target);

		this.entireTimer = scene.children[0];

		// Rotate the timer, so the camera is looking at its center
		this.entireTimer.rotation.y = 0.3;

		// Tilt the timer forward a little to make it look better
		this.entireTimer.position.z = -0.0031;
		this.entireTimer.rotation.x = 0.09;

		this.topHemisphere = this.entireTimer.children[1];
	}

	getTopHemisphereRotation() {
		return this.topHemisphere.rotation.z;
	}

	rotateTopHemisphere(rotation: number) {
		this.topHemisphere.rotation.z = rotation;
	}

	createCamera() {
		const camera = new PerspectiveCamera(40, 1, 0.1, 400);
		camera.position.set(0, 0.035, 0.14);
		camera.aspect = 1;
		camera.updateProjectionMatrix();
		camera.lookAt(new Vector3(0, 0.035, 0));

		return camera;
	}

	createLight() {
		const color = 0xffffff;
		const intensity = 6;
		const light = new DirectionalLight(color, intensity);
		light.position.set(-3, 5, 0);
		light.target.position.set(3, -5, -9);

		return light;
	}

	createRenderer(canvas: HTMLCanvasElement) {
		const renderer = new WebGLRenderer({
			alpha: true,
			antialias: !IS_WEBKIT,
			canvas,
			powerPreference: 'high-performance',
		});
		renderer.setPixelRatio(DEFAULT_PIXEL_RATIO);
		renderer.setClearColor(0x000000, 0);

		return renderer;
	}
}
